import { Alert, AlertDescription, AlertTitle } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { InfoIcon, LockIcon } from 'components/icons';

interface CantEditFormAlertProps {
  isPublished: boolean;
  isClosed: boolean;
}
export const CantEditFormAlert = ({
  isPublished,
  isClosed,
}: CantEditFormAlertProps) => {
  if (!isPublished) {
    return null;
  }

  const title = isClosed
    ? t`You can't edit a closed form`
    : t`You can't edit a published form`;
  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={6}
      borderRadius="lg"
    >
      {isClosed ? <LockIcon size="4x" /> : <InfoIcon size="4x" />}
      <AlertTitle mt={6} mb={1} fontSize="lg">
        {title}
      </AlertTitle>
      <AlertDescription maxWidth="sm">
        {t`You could duplicate this form and edit the copy instead.`}
      </AlertDescription>
    </Alert>
  );
};
